module.exports = __webpack_public_path__ + "img/farmscapes.625835ec.png";